import { GraphQLClient } from 'graphql-request';
import type { RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSONString: { input: string; output: string; }
};

export type AdminDashboardQuery = {
  get?: Maybe<DashboardGetType>;
  instances?: Maybe<Array<Maybe<InstanceOverviewType>>>;
};


export type AdminDashboardQueryGetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeviceCreateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDeviceDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminDeviceMutations = {
  create?: Maybe<AdminDeviceCreateMutation>;
  delete?: Maybe<AdminDeviceDeleteMutation>;
  update?: Maybe<AdminDeviceUpdateMutation>;
};


export type AdminDeviceMutationsCreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  user?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
};


export type AdminDeviceMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type AdminDeviceMutationsUpdateArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AdminDeviceQuery = {
  detail?: Maybe<DeviceType>;
  list?: Maybe<Array<Maybe<DeviceType>>>;
};


export type AdminDeviceQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminDeviceUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventCreateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminEventMutations = {
  create?: Maybe<AdminEventCreateMutation>;
  delete?: Maybe<AdminEventDeleteMutation>;
  update?: Maybe<AdminEventUpdateMutation>;
};


export type AdminEventMutationsCreateArgs = {
  endAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};


export type AdminEventMutationsDeleteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminEventMutationsUpdateArgs = {
  endAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};

export type AdminEventQuery = {
  detail?: Maybe<EventType>;
  list?: Maybe<Array<Maybe<EventType>>>;
};


export type AdminEventQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminEventUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminMutations = {
  device?: Maybe<AdminDeviceMutations>;
  event?: Maybe<AdminEventMutations>;
  ticket?: Maybe<AdminTicketMutations>;
  ticketset?: Maybe<AdminTicketsetMutations>;
  user?: Maybe<AdminUserMutations>;
};

export type AdminQuery = {
  dashboard?: Maybe<AdminDashboardQuery>;
  device?: Maybe<AdminDeviceQuery>;
  event?: Maybe<AdminEventQuery>;
  statistics?: Maybe<AdminStatisticsQuery>;
  ticket?: Maybe<AdminTicketQuery>;
  ticketset?: Maybe<AdminTicketsetQuery>;
  user?: Maybe<AdminUserQuery>;
};

export type AdminStatisticsQuery = {
  get?: Maybe<StatisticsType>;
};


export type AdminStatisticsQueryGetArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  devices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  interval?: InputMaybe<StatisticsIntervalEnum>;
  showEmptyTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zones?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AdminTicketDeleteMultiMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketMutations = {
  delete?: Maybe<AdminTicketDeleteMutation>;
  deleteMulti?: Maybe<AdminTicketDeleteMultiMutation>;
  update?: Maybe<AdminTicketUpdateMutation>;
  upload?: Maybe<AdminTicketUploadMutation>;
};


export type AdminTicketMutationsDeleteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminTicketMutationsDeleteMultiArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type AdminTicketMutationsUpdateArgs = {
  boughtAt?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['Int']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedAt?: InputMaybe<Scalars['String']['input']>;
  usedById?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};


export type AdminTicketMutationsUploadArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  ticketsJson?: InputMaybe<Scalars['String']['input']>;
};

export type AdminTicketQuery = {
  detail?: Maybe<TicketType>;
  list?: Maybe<TicketTypeConnection>;
};


export type AdminTicketQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type AdminTicketQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  ticketset?: InputMaybe<Scalars['ID']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminTicketUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketUploadMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminTicketsetMutations = {
  update?: Maybe<AdminTicketsetUpdateMutation>;
};


export type AdminTicketsetMutationsUpdateArgs = {
  customName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  validate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminTicketsetQuery = {
  list?: Maybe<Array<Maybe<TicketsetType>>>;
};


export type AdminTicketsetQueryListArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AdminTicketsetUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserChangeInstanceMutation = {
  instanceId?: Maybe<Scalars['Int']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  rights?: Maybe<InstanceUserRightsType>;
};

export type AdminUserDeleteMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserLoginMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<UserType>;
};

export type AdminUserLogoutMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserMutations = {
  changeInstance?: Maybe<AdminUserChangeInstanceMutation>;
  delete?: Maybe<AdminUserDeleteMutation>;
  login?: Maybe<AdminUserLoginMutation>;
  logout?: Maybe<AdminUserLogoutMutation>;
  update?: Maybe<AdminUserUpdateMutation>;
  updateRights?: Maybe<AdminUserUpdateRightsMutation>;
};


export type AdminUserMutationsChangeInstanceArgs = {
  instanceName: Scalars['String']['input'];
};


export type AdminUserMutationsDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type AdminUserMutationsLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type AdminUserMutationsUpdateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['String']['input']>;
};


export type AdminUserMutationsUpdateRightsArgs = {
  allowManageDevices?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageEvents?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTickets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageTicketsets?: InputMaybe<Scalars['Boolean']['input']>;
  allowManageUsers?: InputMaybe<Scalars['Boolean']['input']>;
  allowStats?: InputMaybe<Scalars['Boolean']['input']>;
  bzucoAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  instanceId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type AdminUserQuery = {
  detail?: Maybe<UserType>;
  list?: Maybe<Array<Maybe<UserType>>>;
  logged?: Maybe<UserType>;
  zones?: Maybe<Array<Maybe<ZoneType>>>;
};


export type AdminUserQueryDetailArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminUserUpdateMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminUserUpdateRightsMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AlertType = {
  kind?: Maybe<Scalars['String']['output']>;
  relatedId?: Maybe<Scalars['Int']['output']>;
  relatedName?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
};

export type CheckpointType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ticketsets: Array<TicketsetType>;
  user: UserType;
};

export type DashboardEventType = {
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scanRateLastHour?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsUsed?: Maybe<Scalars['Int']['output']>;
};

export type DashboardGetType = {
  activeDevicesCount?: Maybe<Scalars['Int']['output']>;
  activeEvents?: Maybe<Array<Maybe<DashboardEventType>>>;
  alerts?: Maybe<Array<Maybe<AlertType>>>;
  hourlyValidations?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  recentScans?: Maybe<Array<Maybe<ScanLogType>>>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsUsed?: Maybe<Scalars['Int']['output']>;
  totalDevicesCount?: Maybe<Scalars['Int']['output']>;
  upcomingEventsCount?: Maybe<Scalars['Int']['output']>;
  validationsLast24h?: Maybe<Scalars['Int']['output']>;
  validationsPrev24h?: Maybe<Scalars['Int']['output']>;
};

export type DeviceType = {
  id?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<InstanceType>;
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  ticketSet: TicketTypeConnection;
  username: Scalars['String']['output'];
};


export type DeviceTypeTicketSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EventType = {
  bzucoId: Scalars['Int']['output'];
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instance?: Maybe<InstanceType>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  ticketsets: Array<TicketsetType>;
};

export type InstanceOverviewType = {
  activeEventsCount?: Maybe<Scalars['Int']['output']>;
  devicesOnline?: Maybe<Scalars['Int']['output']>;
  devicesTotal?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scansLast24h?: Maybe<Scalars['Int']['output']>;
};

export type InstanceType = {
  devices: Array<DeviceType>;
  events: Array<EventType>;
  id: Scalars['ID']['output'];
  instanceuserrightsSet: Array<InstanceUserRightsType>;
  name: Scalars['String']['output'];
  users: Array<UserType>;
  zones: Array<ZoneType>;
};

export type InstanceUserRightsType = {
  allowManageDevices: Scalars['Boolean']['output'];
  allowManageEvents: Scalars['Boolean']['output'];
  allowManageTickets: Scalars['Boolean']['output'];
  allowManageTicketsets: Scalars['Boolean']['output'];
  allowManageUsers: Scalars['Boolean']['output'];
  allowStats: Scalars['Boolean']['output'];
  bzucoAdmin: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instance: InstanceType;
  primary: Scalars['Boolean']['output'];
  user: UserType;
};

export type MobileLoginMutation = {
  device?: Maybe<DeviceType>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileLogoutMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileMutations = {
  login?: Maybe<MobileLoginMutation>;
  logout?: Maybe<MobileLogoutMutation>;
  ticketDirectUseOnline?: Maybe<MobileTicketDirectUseOnlineMutation>;
  ticketUse?: Maybe<MobileTicketUseMutation>;
  ticketUseOnline?: Maybe<MobileTicketUseOnlineMutation>;
  ticketsReset?: Maybe<MobileTicketsResetMutation>;
};


export type MobileMutationsLoginArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MobileMutationsTicketDirectUseOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileMutationsTicketUseArgs = {
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
};


export type MobileMutationsTicketUseOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileMutationsTicketsResetArgs = {
  ticketsetId?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileQuery = {
  events?: Maybe<Array<Maybe<EventType>>>;
  info?: Maybe<Scalars['String']['output']>;
  infoData?: Maybe<TicketInfoDataType>;
  online?: Maybe<TicketOnlineType>;
  tickets?: Maybe<Array<Maybe<TicketsTicketsetType>>>;
  ticketsReader?: Maybe<Scalars['JSONString']['output']>;
  ticketsUpdated?: Maybe<Array<Maybe<TicketsTicketsetType>>>;
  userLogged?: Maybe<UserLoggedQueryType>;
  zoneStats?: Maybe<Array<Maybe<ZoneStatsType>>>;
  zones?: Maybe<Array<Maybe<ZoneType>>>;
};


export type MobileQueryEventsArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MobileQueryInfoArgs = {
  code: Scalars['String']['input'];
};


export type MobileQueryInfoDataArgs = {
  code: Scalars['String']['input'];
};


export type MobileQueryOnlineArgs = {
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsArgs = {
  checkpointId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsReaderArgs = {
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryTicketsUpdatedArgs = {
  checkpointId?: InputMaybe<Scalars['Int']['input']>;
  ticketsets?: InputMaybe<Array<InputMaybe<Scalars['JSONString']['input']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MobileQueryZoneStatsArgs = {
  day?: InputMaybe<Scalars['Date']['input']>;
};

export type MobileTicketDirectUseOnlineMutation = {
  display?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  ticket?: Maybe<TicketType>;
};

export type MobileTicketUseMutation = {
  display?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MobileTicketUseOnlineMutation = {
  display?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
};

export type MobileTicketsResetMutation = {
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutations = {
  admin?: Maybe<AdminMutations>;
  mobile?: Maybe<MobileMutations>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PriceType = {
  bzucoId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  people: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  tickets: TicketTypeConnection;
  ticketset: TicketsetType;
  title: Scalars['String']['output'];
};


export type PriceTypeTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  admin?: Maybe<AdminQuery>;
  mobile?: Maybe<MobileQuery>;
};

export type ScanLogType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ticketCode?: Maybe<Scalars['String']['output']>;
  ticketsetName?: Maybe<Scalars['String']['output']>;
};

export type SlotType = {
  bzucoId: Scalars['Int']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lang: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  validSince?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zone: ZoneType;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export type StatisticsDeviceType = {
  count?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum StatisticsIntervalEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE'
}

export type StatisticsTicketsetSumSubType = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type StatisticsTicketsetSumType = {
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  real?: Maybe<Scalars['Int']['output']>;
  realNodevice?: Maybe<Scalars['Int']['output']>;
  sub?: Maybe<Array<Maybe<StatisticsTicketsetSumSubType>>>;
  total?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
};

export type StatisticsType = {
  device?: Maybe<Array<Maybe<StatisticsDeviceType>>>;
  interval?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  misc?: Maybe<Scalars['JSONString']['output']>;
  ticketsTotal?: Maybe<Scalars['Int']['output']>;
  ticketsValidated?: Maybe<Scalars['Int']['output']>;
  ticketsetSums?: Maybe<Array<Maybe<StatisticsTicketsetSumType>>>;
  ticketsetSumsTotal?: Maybe<StatisticsTicketsetSumType>;
};

export type TicketInfoDataLogType = {
  created?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['Int']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataRemainType = {
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataSlotType = {
  bzucoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataType = {
  created?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Scalars['Int']['output']>;
  entryPause?: Maybe<Scalars['Int']['output']>;
  eventBzucoId?: Maybe<Scalars['Int']['output']>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  people?: Maybe<Scalars['Int']['output']>;
  priceBzucoId?: Maybe<Scalars['Int']['output']>;
  priceId?: Maybe<Scalars['Int']['output']>;
  priceName?: Maybe<Scalars['String']['output']>;
  remainingEntriesForZone?: Maybe<Array<Maybe<TicketInfoDataRemainType>>>;
  remainingPeopleForZone?: Maybe<Array<Maybe<TicketInfoDataRemainType>>>;
  slots?: Maybe<Array<Maybe<TicketInfoDataSlotType>>>;
  ticketsetBzucoId?: Maybe<Scalars['Int']['output']>;
  ticketsetId?: Maybe<Scalars['Int']['output']>;
  ticketsetName?: Maybe<Scalars['String']['output']>;
  usageForZone?: Maybe<Array<Maybe<TicketInfoDataUsageType>>>;
  usageLogs?: Maybe<Array<Maybe<TicketInfoDataLogType>>>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zones?: Maybe<Array<Maybe<TicketInfoDataZoneType>>>;
};

export type TicketInfoDataUsageType = {
  display?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Scalars['Int']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextEntryAt?: Maybe<Scalars['String']['output']>;
  remains?: Maybe<Scalars['Int']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
};

export type TicketInfoDataZoneType = {
  bzucoId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TicketOnlineType = {
  display?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  ticketset?: Maybe<TicketsetType>;
  used?: Maybe<Scalars['Boolean']['output']>;
  usedAt?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<Scalars['String']['output']>;
  zonesUsed?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type TicketType = Node & {
  boughtAt?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  price?: Maybe<PriceType>;
  slotValidSince?: Maybe<Scalars['JSONString']['output']>;
  slotValidUntil?: Maybe<Scalars['JSONString']['output']>;
  slots: Scalars['String']['output'];
  ticketNumber: Scalars['String']['output'];
  ticketset?: Maybe<TicketsetType>;
  updatedAt: Scalars['DateTime']['output'];
  updatedAtString?: Maybe<Scalars['String']['output']>;
  used: Scalars['Boolean']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAtString?: Maybe<Scalars['String']['output']>;
  usedBy?: Maybe<DeviceType>;
  usedOnCheckpoint?: Maybe<Scalars['Boolean']['output']>;
  usedTotal: Scalars['Int']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  zoneList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  zones: Scalars['String']['output'];
};

export type TicketTypeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TicketTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TicketType` and its cursor. */
export type TicketTypeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TicketType>;
};

export type TicketsTicketsetType = {
  tickets?: Maybe<Array<Maybe<TicketType>>>;
  ticketsetId?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TicketsetType = {
  bzucoId: Scalars['Int']['output'];
  checkpointSet: Array<CheckpointType>;
  customName: Scalars['String']['output'];
  entries: Scalars['Int']['output'];
  entryPause: Scalars['Int']['output'];
  event: EventType;
  id?: Maybe<Scalars['Int']['output']>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  prices: Array<PriceType>;
  ticketCount?: Maybe<Scalars['Int']['output']>;
  unlimited: Scalars['Boolean']['output'];
  validate: Scalars['Boolean']['output'];
  validatedCount?: Maybe<Scalars['Int']['output']>;
};

export type UserLoggedQueryType = {
  device?: Maybe<DeviceType>;
  user?: Maybe<UserType>;
};

export type UserProfileType = {
  bzucoAdmin: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instance: Scalars['String']['output'];
  user: UserType;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type UserType = {
  activeInstance?: Maybe<InstanceType>;
  dateJoined: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  instances?: Maybe<Array<Maybe<InstanceUserRightsType>>>;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean']['output'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean']['output'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  password: Scalars['String']['output'];
  profile?: Maybe<UserProfileType>;
  rights?: Maybe<InstanceUserRightsType>;
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String']['output'];
};

export type ZoneStatsType = {
  name?: Maybe<Scalars['String']['output']>;
  today?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ZoneType = {
  bzucoId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instance?: Maybe<InstanceType>;
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slots: Array<SlotType>;
  validSince: Scalars['Int']['output'];
  validUntil: Scalars['Int']['output'];
};

export type MobileEventsQueryVariables = Exact<{
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type MobileEventsQuery = { mobile?: { events?: Array<{ id?: number | null, name: string, startAt?: string | null, endAt?: string | null, ticketsets: Array<{ id?: number | null, name: string, customName: string, validate: boolean, count?: number | null }> } | null> | null } | null };

export type MobileInfoQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type MobileInfoQuery = { mobile?: { info?: string | null } | null };

export type MobileInfoDataQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type MobileInfoDataQuery = { mobile?: { infoData?: { ok?: boolean | null, message?: string | null, email?: string | null, entries?: number | null, entryPause?: number | null, people?: number | null, eventId?: number | null, eventBzucoId?: number | null, eventName?: string | null, ticketsetId?: number | null, ticketsetBzucoId?: number | null, ticketsetName?: string | null, priceId?: number | null, priceBzucoId?: number | null, priceName?: string | null, created?: string | null, validUntil?: string | null, remainingEntriesForZone?: Array<{ id?: number | null, name?: string | null, count?: number | null } | null> | null, remainingPeopleForZone?: Array<{ id?: number | null, name?: string | null, count?: number | null } | null> | null, zones?: Array<{ id?: number | null, bzucoId?: number | null, name?: string | null } | null> | null, slots?: Array<{ id?: number | null, bzucoId?: number | null, startAt?: string | null } | null> | null, usageForZone?: Array<{ id?: number | null, name?: string | null, used?: boolean | null, usedAt?: string | null, usedBy?: string | null, extra?: string | null, display?: string | null, remains?: number | null, entries?: number | null, nextEntryAt?: string | null } | null> | null, usageLogs?: Array<{ created?: string | null, deviceId?: number | null, deviceName?: string | null, zoneId?: number | null, zoneName?: string | null } | null> | null } | null } | null };

export type LoginUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { mobile?: { login?: { ok?: boolean | null, message?: string | null, device?: { name: string } | null } | null } | null };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { mobile?: { logout?: { ok?: boolean | null } | null } | null };

export type TicketDirectUseOnlineMutationVariables = Exact<{
  code: Scalars['String']['input'];
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type TicketDirectUseOnlineMutation = { mobile?: { ticketDirectUseOnline?: { ok?: boolean | null, message?: string | null, ticket?: { id: string, used: boolean, usedAt?: string | null, usedBy?: { id?: number | null, name: string } | null, ticketset?: { id?: number | null, name: string, customName: string, validate: boolean } | null, price?: { id?: number | null, name: string } | null } | null } | null } | null };

export type TicketOnlineQueryVariables = Exact<{
  code: Scalars['String']['input'];
  ticketsetId: Scalars['Int']['input'];
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type TicketOnlineQuery = { mobile?: { online?: { used?: boolean | null, usedAt?: string | null, usedBy?: string | null, extra?: string | null, display?: string | null, zonesUsed?: Array<number | null> | null, ticketset?: { id?: number | null, name: string, customName: string, validate: boolean } | null } | null } | null };

export type TicketUseMutationVariables = Exact<{
  ticketsetId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
}>;


export type TicketUseMutation = { mobile?: { ticketUse?: { ok?: boolean | null, message?: string | null } | null } | null };

export type TicketUseOnlineMutationVariables = Exact<{
  ticketsetId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  checkpoint?: InputMaybe<Scalars['Int']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type TicketUseOnlineMutation = { mobile?: { ticketUseOnline?: { ok?: boolean | null, message?: string | null, usedAt?: string | null, usedBy?: string | null, extra?: string | null, display?: string | null } | null } | null };

export type TicketsQueryVariables = Exact<{
  ticketsetIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type TicketsQuery = { mobile?: { tickets?: Array<{ ticketsetId?: number | null, tickets?: Array<{ id: string, code: string, used: boolean, usedAt?: string | null, ticketNumber: string, firstName: string, lastName: string, updatedAt: string, isOnline?: boolean | null, usedBy?: { name: string } | null, price?: { name: string } | null } | null> | null } | null> | null } | null };

export type TicketsResetMutationVariables = Exact<{
  ticketsetId: Scalars['Int']['input'];
}>;


export type TicketsResetMutation = { mobile?: { ticketsReset?: { ok?: boolean | null } | null } | null };

export type TicketsUpdatedQueryVariables = Exact<{
  ticketsets?: InputMaybe<Array<InputMaybe<Scalars['JSONString']['input']>> | InputMaybe<Scalars['JSONString']['input']>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type TicketsUpdatedQuery = { mobile?: { ticketsUpdated?: Array<{ ticketsetId?: number | null, tickets?: Array<{ id: string, code: string, used: boolean, usedAt?: string | null, ticketNumber: string, firstName: string, lastName: string, updatedAt: string, usedBy?: { name: string } | null, price?: { name: string } | null } | null> | null } | null> | null } | null };

export type UserLoggedQueryVariables = Exact<{ [key: string]: never; }>;


export type UserLoggedQuery = { mobile?: { userLogged?: { device?: { name: string } | null } | null } | null };

export type MobileZoneStatsQueryVariables = Exact<{
  day: Scalars['Date']['input'];
}>;


export type MobileZoneStatsQuery = { mobile?: { zoneStats?: Array<{ name?: string | null, today?: number | null, total?: number | null } | null> | null } | null };

export type ZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type ZonesQuery = { mobile?: { zones?: Array<{ id: string, name: string } | null> | null } | null };


export const MobileEventsDocument = gql`
    query MobileEvents($fromDate: DateTime) {
  mobile {
    events(fromDate: $fromDate) {
      id
      name
      startAt
      endAt
      ticketsets {
        id
        name
        customName
        validate
        count: ticketCount
      }
    }
  }
}
    `;
export const MobileInfoDocument = gql`
    query MobileInfo($code: String!) {
  mobile {
    info(code: $code)
  }
}
    `;
export const MobileInfoDataDocument = gql`
    query MobileInfoData($code: String!) {
  mobile {
    infoData(code: $code) {
      ok
      message
      email
      entries
      entryPause
      people
      eventId
      eventBzucoId
      eventName
      ticketsetId
      ticketsetBzucoId
      ticketsetName
      priceId
      priceBzucoId
      priceName
      created
      validUntil
      remainingEntriesForZone {
        id
        name
        count
      }
      remainingPeopleForZone {
        id
        name
        count
      }
      zones {
        id
        bzucoId
        name
      }
      slots {
        id
        bzucoId
        startAt
      }
      usageForZone {
        id
        name
        used
        usedAt
        usedBy
        extra
        display
        remains
        entries
        nextEntryAt
      }
      usageLogs {
        created
        deviceId
        deviceName
        zoneId
        zoneName
      }
    }
  }
}
    `;
export const LoginUserDocument = gql`
    mutation LoginUser($username: String!, $password: String!) {
  mobile {
    login(username: $username, password: $password) {
      ok
      message
      device {
        name
      }
    }
  }
}
    `;
export const LogoutUserDocument = gql`
    mutation LogoutUser {
  mobile {
    logout {
      ok
    }
  }
}
    `;
export const TicketDirectUseOnlineDocument = gql`
    mutation TicketDirectUseOnline($code: String!, $checkpoint: Int, $zoneIds: [Int!]) {
  mobile {
    ticketDirectUseOnline(code: $code, checkpoint: $checkpoint, zoneIds: $zoneIds) {
      ok
      message
      ticket {
        id
        used
        usedBy {
          id
          name
        }
        usedAt
        ticketset {
          id
          name
          customName
          validate
        }
        price {
          id
          name
        }
      }
    }
  }
}
    `;
export const TicketOnlineDocument = gql`
    query TicketOnline($code: String!, $ticketsetId: Int!, $checkpoint: Int, $zoneIds: [Int!]) {
  mobile {
    online(
      code: $code
      ticketsetId: $ticketsetId
      checkpoint: $checkpoint
      zoneIds: $zoneIds
    ) {
      used
      usedAt
      usedBy
      extra
      display
      zonesUsed
      ticketset {
        id
        name
        customName
        validate
      }
    }
  }
}
    `;
export const TicketUseDocument = gql`
    mutation TicketUse($ticketsetId: Int!, $code: String!) {
  mobile {
    ticketUse(ticketsetId: $ticketsetId, code: $code) {
      ok
      message
    }
  }
}
    `;
export const TicketUseOnlineDocument = gql`
    mutation TicketUseOnline($ticketsetId: Int!, $code: String!, $checkpoint: Int, $zoneIds: [Int!]) {
  mobile {
    ticketUseOnline(
      ticketsetId: $ticketsetId
      code: $code
      checkpoint: $checkpoint
      zoneIds: $zoneIds
    ) {
      ok
      message
      usedAt
      usedBy
      extra
      display
    }
  }
}
    `;
export const TicketsDocument = gql`
    query Tickets($ticketsetIds: [Int], $zoneIds: [Int]) {
  mobile {
    tickets(ticketsetIds: $ticketsetIds, zoneIds: $zoneIds) {
      ticketsetId
      tickets {
        id
        code
        used
        usedAt
        usedBy {
          name
        }
        ticketNumber
        firstName
        lastName
        updatedAt
        isOnline
        price {
          name
        }
      }
    }
  }
}
    `;
export const TicketsResetDocument = gql`
    mutation TicketsReset($ticketsetId: Int!) {
  mobile {
    ticketsReset(ticketsetId: $ticketsetId) {
      ok
    }
  }
}
    `;
export const TicketsUpdatedDocument = gql`
    query TicketsUpdated($ticketsets: [JSONString], $zoneIds: [Int]) {
  mobile {
    ticketsUpdated(ticketsets: $ticketsets, zoneIds: $zoneIds) {
      ticketsetId
      tickets {
        id
        code
        used
        usedAt
        usedBy {
          name
        }
        ticketNumber
        firstName
        lastName
        updatedAt
        price {
          name
        }
      }
    }
  }
}
    `;
export const UserLoggedDocument = gql`
    query UserLogged {
  mobile {
    userLogged {
      device {
        name
      }
    }
  }
}
    `;
export const MobileZoneStatsDocument = gql`
    query MobileZoneStats($day: Date!) {
  mobile {
    zoneStats(day: $day) {
      name
      today
      total
    }
  }
}
    `;
export const ZonesDocument = gql`
    query Zones {
  mobile {
    zones {
      id
      name
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    MobileEvents(variables?: MobileEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MobileEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MobileEventsQuery>({ document: MobileEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MobileEvents', 'query', variables);
    },
    MobileInfo(variables: MobileInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MobileInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MobileInfoQuery>({ document: MobileInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MobileInfo', 'query', variables);
    },
    MobileInfoData(variables: MobileInfoDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MobileInfoDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MobileInfoDataQuery>({ document: MobileInfoDataDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MobileInfoData', 'query', variables);
    },
    LoginUser(variables: LoginUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LoginUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginUserMutation>({ document: LoginUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LoginUser', 'mutation', variables);
    },
    LogoutUser(variables?: LogoutUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<LogoutUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutUserMutation>({ document: LogoutUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'LogoutUser', 'mutation', variables);
    },
    TicketDirectUseOnline(variables: TicketDirectUseOnlineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketDirectUseOnlineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketDirectUseOnlineMutation>({ document: TicketDirectUseOnlineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketDirectUseOnline', 'mutation', variables);
    },
    TicketOnline(variables: TicketOnlineQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketOnlineQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketOnlineQuery>({ document: TicketOnlineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketOnline', 'query', variables);
    },
    TicketUse(variables: TicketUseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketUseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketUseMutation>({ document: TicketUseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketUse', 'mutation', variables);
    },
    TicketUseOnline(variables: TicketUseOnlineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketUseOnlineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketUseOnlineMutation>({ document: TicketUseOnlineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketUseOnline', 'mutation', variables);
    },
    Tickets(variables?: TicketsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketsQuery>({ document: TicketsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Tickets', 'query', variables);
    },
    TicketsReset(variables: TicketsResetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketsResetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketsResetMutation>({ document: TicketsResetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketsReset', 'mutation', variables);
    },
    TicketsUpdated(variables?: TicketsUpdatedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TicketsUpdatedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TicketsUpdatedQuery>({ document: TicketsUpdatedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TicketsUpdated', 'query', variables);
    },
    UserLogged(variables?: UserLoggedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UserLoggedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserLoggedQuery>({ document: UserLoggedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UserLogged', 'query', variables);
    },
    MobileZoneStats(variables: MobileZoneStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MobileZoneStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MobileZoneStatsQuery>({ document: MobileZoneStatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MobileZoneStats', 'query', variables);
    },
    Zones(variables?: ZonesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ZonesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ZonesQuery>({ document: ZonesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Zones', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;